import React from 'react';
import { useTranslation } from 'react-i18next';
import { BaseLayout } from '../../shared/BaseLayout/BaseLayout';
import { Container, Square, Left, Right } from './PasswordReset.styled';
import { Title } from '../../constants/base';
import { PassReset } from '../../components/PassReset/PassReset';

export const PasswordReset = () => {
  const { t } = useTranslation();

  return (
    <BaseLayout>
      <Container>
        <Square>
          <Left>
            <Title>{t('PasswordReset.formLeft.title')}</Title>
          </Left>
          <Right>
            <PassReset />
          </Right>
        </Square>
      </Container>
    </BaseLayout>
  );
};
